"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.noIcon = exports.checkedIcon = exports.useBaseStyles = void 0;
var react_1 = __importDefault(require("react"));
var system_1 = require("../../system");
var CheckedSmall_1 = require("../icons/CheckedSmall");
var checkedStyle = function (theme) { return ({
    '&$root$go': {
        color: theme.schemes.colors.system.BgMain,
        backgroundColor: theme.schemes.colors.system.ControlMain,
        '&:hover': {
            backgroundColor: theme.schemes.colors.system.ControlMain,
        },
    },
}); };
exports.useBaseStyles = (0, system_1.makeStyles)(function (theme) {
    var checked = checkedStyle(theme.go);
    var focused = {
        border: "2px solid ".concat(theme.go.schemes.colors.system.IconMain),
    };
    return {
        go: {},
        labelRoot: {
            '&$go': {
                width: '100%',
                color: theme.go.schemes.colors.system.TextMain,
                margin: 0,
                userSelect: 'none',
            },
        },
        labelDisabled: {
            // рутовый класс
            '&$go': {
                opacity: 0.6,
                pointerEvents: 'none',
            },
            // класс на самом лейбле
            '$go &': {
                color: theme.go.schemes.colors.system.TextMain,
            },
        },
        root: {
            boxSizing: 'border-box',
            marginRight: function (props) {
                return props.labelPlacement === 'end' ? 12 : undefined;
            },
            marginLeft: function (props) {
                return props.labelPlacement === 'start' ? 12 : undefined;
            },
            '[dir="rtl"] &': {
                marginLeft: function (props) {
                    return props.labelPlacement === 'end' ? 12 : undefined;
                },
                marginRight: function (props) {
                    return props.labelPlacement === 'start' ? 12 : undefined;
                },
            },
            '&$go': __assign(__assign(__assign(__assign({ color: theme.go.schemes.colors.system.BgMain, backgroundColor: theme.go.schemes.colors.system.ControlMinor, '&:hover': {
                    backgroundColor: theme.go.schemes.colors.system.ControlMinor,
                }, '&:focus-within': focused, '&:active': focused, '$labelRoot:active &': focused }, theme.go.mixins.effects.Hovered()), theme.go.mixins.effects.Pressed()), theme.go.mixins.effects.Hovered('$labelRoot:hover &')), theme.go.mixins.effects.Pressed('$labelRoot:hover:active &')),
        },
        checked: checked,
        indeterminate: checked,
        labelText: __assign({ width: '100%', overflowX: 'hidden' }, theme.go.mixins.typography.Body),
        disabled: {
            '&$go': {
                backgroundColor: theme.go.schemes.colors.system.ControlMinor,
                opacity: 0.6,
                // внутри лейбла опасити выставится сверху
                '$labelRoot &': {
                    opacity: 1,
                },
                '&$checked': {
                    backgroundColor: theme.go.schemes.colors.system.ControlMain,
                },
                '&$indeterminate': {
                    backgroundColor: theme.go.schemes.colors.system.ControlMain,
                },
            },
        },
    };
}, { name: 'GoSwitchesBase' });
exports.checkedIcon = react_1.default.createElement(CheckedSmall_1.CheckedSmallIcon, null);
exports.noIcon = react_1.default.createElement("svg", { viewBox: "0 0 0 0", width: "0", height: "0" });
